// // // ============================================================
// // // CUSTOM ORDER - Shopify Contact Form + EmailJS
// // // ============================================================

// // (function() {
  
// //   console.log('🚀 Custom Order JS loaded');
  
// //   // Initialize EmailJS
// //   if (typeof emailjs !== 'undefined') {
// //     emailjs.init("XZsjOIpLyMDQNMrIE");
// //     console.log('✅ EmailJS initialized');
// //   }

// //   // Function to show Thank You popup
// //   function showThankYouPopup() {
// //     console.log('🎉 Showing Thank You popup');
// //     if ($('#ThankYouModal').length > 0) {
// //       $('#ThankYouModal').modal('show');
// //       setTimeout(function() {
// //         $('#ThankYouModal').modal('hide');
// //       }, 5000);
// //     } else {
// //       console.log('❌ ThankYouModal not found');
// //     }
// //   }

// //   // Function to show error message
// //   function showError(message) {
// //     $('#CustomOrderFormStatus').html(
// //       '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">✗ ' + message + '</div>'
// //     );
// //   }

// //   function showSuccess(message) {
// //     $('#CustomOrderFormStatus').html(
// //       '<div style="color: #155724; padding: 12px; background: #d4edda; border-radius: 8px;">✓ ' + message + '</div>'
// //     );
// //   }

// //   // Check URL parameters on page load
// //   function checkForFormSubmission() {
// //     var urlParams = new URLSearchParams(window.location.search);
    
// //     if (urlParams.get('contact_posted') === 'true') {
// //       console.log('✅ Form was submitted, showing Thank You popup');
      
// //       var storedData = sessionStorage.getItem('customOrderData');
// //       if (storedData) {
// //         var data = JSON.parse(storedData);
// //         console.log('📤 Sending thank you email via EmailJS');
        
// //         emailjs.send(
// //           "service_9t2yids",
// //           "template_3xv47ep",
// //           {
// //             full_name: data.name,
// //             customer_email: data.email,
// //             phone: data.phone,
// //             address: data.address || 'Not provided',
// //             specifications: data.specs,
// //             product_name: data.productName,
// //             product_variant: data.productVariant,
// //             product_url: data.productUrl
// //           }
// //         ).then(function() {
// //           console.log('✅ Customer confirmation email sent via EmailJS');
// //           sessionStorage.removeItem('customOrderData');
// //         }).catch(function(error) {
// //           console.error('❌ EmailJS error:', error);
// //         });
// //       }
      
// //       setTimeout(function() {
// //         showThankYouPopup();
// //       }, 500);
      
// //       if (window.history && window.history.replaceState) {
// //         var cleanUrl = window.location.pathname + window.location.search.replace(/[?&]contact_posted=true/, '').replace(/^&/, '?');
// //         window.history.replaceState({}, document.title, cleanUrl);
// //       }
// //     }
// //   }

// //   $(document).ready(function() {
// //     console.log('✅ Document ready - setting up custom order');

// //     // ✅ CUSTOM ORDER BUTTON CLICK HANDLER - For both product page and collection page
// //     $(document).on('click', '.btn-custom-order, .btn-custom-order-collection', function(e) {
// //       e.preventDefault();
// //       e.stopPropagation();
// //       e.stopImmediatePropagation();

// //       console.log('🔘 Custom Order button clicked (Collection or Product page)');

// //       var productName = $(this).data('product-name') || window.__productTitle || 'Custom Product';
// //       var productUrl = $(this).data('product-url') || window.location.href;
// //       var productVariant = $(this).data('product-variant') || '';

// //       $('#co-product-name').val(productName);
// //       $('#co-product-url').val(productUrl);
// //       $('#co-product-variant').val(productVariant);

// //       // Reset form
// //       $('#custom-order-form')[0].reset();
// //       $('#CustomOrderFormStatus').html('');

// //       // Ensure modal is attached to body
// //       if ($('#CustomOrderModal').parent()[0] !== document.body) {
// //         $('#CustomOrderModal').appendTo('body');
// //       }
      
// //       // Close any other open modals
// //       $('.modal.show').modal('hide');

// //       // Show custom order modal
// //       setTimeout(function() {
// //         $('#CustomOrderModal').modal('show');
// //       }, 400);
      
// //       return false;
// //     });

// //     // Check if form was just submitted
// //     checkForFormSubmission();

// //     var form = $('#custom-order-form');
    
// //     if (form.length === 0) {
// //       console.log('⚠️ custom-order-form not found');
// //       return;
// //     }

// //     // ✅ NATIVE FORM SUBMIT (ALLOWS CAPTCHA)
// //     form.on('submit', function(e) {
// //       var submitBtn = form.find('.btn-submit-request');
// //       var originalText = submitBtn.html();
      
// //       // Validate required fields
// //       var name = form.find('input[name="contact[name]"]').val().trim();
// //       var email = form.find('input[name="contact[email]"]').val().trim();
// //       var phone = form.find('input[name="contact[phone]"]').val().trim();
// //       var specs = form.find('textarea[name="contact[body]"]').val().trim();
      
// //       if (!name || !email || !phone || !specs) {
// //         $('#CustomOrderFormStatus').html(
// //           '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">✗ Please fill in all required fields.</div>'
// //         );
// //         e.preventDefault();
// //         return false;
// //       }
      
// //       var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// //       if (!emailRegex.test(email)) {
// //         $('#CustomOrderFormStatus').html(
// //           '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">✗ Please enter a valid email address.</div>'
// //         );
// //         e.preventDefault();
// //         return false;
// //       }
      
// //       // Show loading state
// //       submitBtn.html('SENDING...').prop('disabled', true);
// //       $('#CustomOrderFormStatus').html(
// //         '<div style="color: #856404; padding: 12px; background: #fff3cd; border-radius: 8px;">⏳ Sending your request...</div>'
// //       );
      
// //       // Store form data for after redirect
// //       try {
// //         sessionStorage.setItem('customOrderData', JSON.stringify({
// //           name: name,
// //           email: email,
// //           phone: phone,
// //           address: form.find('textarea[name="contact[address]"]').val().trim(),
// //           specs: specs,
// //           productName: form.find('input[name="contact[Product Name]"]').val(),
// //           productUrl: form.find('input[name="contact[Product URL]"]').val(),
// //           productVariant: form.find('input[name="contact[Product Variant]"]').val()
// //         }));
// //       } catch(e) {
// //         console.warn('Could not save to sessionStorage', e);
// //       }
      
// //       // Allow form submission to proceed (this handles CAPTCHA automatically)
// //       console.log('✅ Form validation passed, submitting natively...');
// //       return true;
// //     });

// //     // ============================================================
// //     // CUSTOM ORDER - Variant change button visibility (Product Page)
// //     // ============================================================
// //     var productTags = window.__productTags || [];
// //     var isCustomize = productTags.indexOf('customize') !== -1;

// //     if (isCustomize) {
// //       console.log('✅ Customize product detected on product page');
// //       var variants = window.__productVariants || [];

// //       function getVariantById(id) {
// //         return variants.find(function(v) { return v.id == id; });
// //       }

// //       function updateCustomButtons(available) {
// //         var customBtn = document.querySelector('.btn-custom-order');
// //         var addToCartBtn = document.querySelector('.btnAddToCart');
// //         var notifyBtn = document.querySelector('.btnsold_out.sold_out');
        
// //         if (!customBtn) return;
// //         console.log('🔄 Updating buttons - available:', available);

// //         if (available) {
// //           customBtn.style.setProperty('display', 'block', 'important');
// //           if (addToCartBtn) addToCartBtn.style.setProperty('display', 'none', 'important');
// //           if (notifyBtn) notifyBtn.style.setProperty('display', 'none', 'important');
// //         } else {
// //           customBtn.style.setProperty('display', 'none', 'important');
// //           if (addToCartBtn) addToCartBtn.style.setProperty('display', 'none', 'important');
// //           if (notifyBtn) notifyBtn.style.setProperty('display', 'flex', 'important');
// //         }
// //       }

// //       var variantInput = document.getElementById('variant_id');
// //       if (variantInput) {
// //         var observer = new MutationObserver(function() {
// //           var variant = getVariantById(parseInt(variantInput.value));
// //           if (variant) updateCustomButtons(variant.available);
// //         });
// //         observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        
// //         var initialVariant = getVariantById(parseInt(variantInput.value));
// //         if (initialVariant) updateCustomButtons(initialVariant.available);
// //       }

// //       document.addEventListener('change', function(e) {
// //         if (e.target.classList.contains('jash-click')) {
// //           setTimeout(function() {
// //             var input = document.getElementById('variant_id');
// //             if (!input) return;
// //             var variant = getVariantById(parseInt(input.value));
// //             if (variant) updateCustomButtons(variant.available);
// //           }, 150);
// //         }
// //       });
// //     }

// //   });

// // })();


// // // ============================================================
// // // CUSTOM ORDER - WORKING VERSION
// // // ============================================================

// // (function() {
  
// //   console.log('🚀 Custom Order JS loaded');

// //   // Initialize EmailJS
// //   if (typeof emailjs !== 'undefined') {
// //     emailjs.init("XZsjOIpLyMDQNMrIE");
// //     console.log('✅ EmailJS initialized');
// //   }

// //   // Function to send Thank You email to customer
// //   function sendThankYouEmail(customerData) {
// //     console.log('📤 Sending thank you email to customer...');
// //     console.log('Customer Data:', customerData);
    
// //     emailjs.send(
// //       "service_9t2yids",
// //       "template_3xv47ep",
// //       {
// //         full_name: customerData.name,
// //         customer_email: customerData.email,
// //         phone: customerData.phone,
// //         address: customerData.address || 'Not provided',
// //         specifications: customerData.specs,
// //         product_name: customerData.productName,
// //         product_variant: customerData.productVariant,
// //         product_url: customerData.productUrl
// //       }
// //     ).then(function(response) {
// //       console.log('✅ Thank you email sent to customer!', response);
// //     }).catch(function(error) {
// //       console.error('❌ Failed to send thank you email:', error);
// //     });
// //   }

// //   // Show Thank You Popup
// //   function showThankYouPopup() {
// //     console.log('🎉 Showing Thank You popup');
// //     if ($('#ThankYouModal').length > 0) {
// //       $('#ThankYouModal').modal({
// //         backdrop: 'static',
// //         keyboard: true
// //       });
// //       $('#ThankYouModal').modal('show');
      
// //       setTimeout(function() {
// //         $('#ThankYouModal').modal('hide');
// //       }, 5000);
// //     }
// //   }

// //   // Handle Form Submission - Using Native Form Submission
// //   function submitCustomOrder(form) {
// //     var name = form.find('input[name="contact[name]"]').val().trim();
// //     var email = form.find('input[name="contact[email]"]').val().trim();
// //     var phone = form.find('input[name="contact[phone]"]').val().trim();
// //     var address = form.find('textarea[name="contact[address]"]').val().trim();
// //     var specs = form.find('textarea[name="contact[body]"]').val().trim();
    
// //     // Validate
// //     if (!name || !email || !phone || !specs) {
// //       $('#CustomOrderFormStatus').html(
// //         '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">✗ Please fill in all required fields.</div>'
// //       );
// //       return false;
// //     }
    
// //     // Validate email
// //     var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// //     if (!emailRegex.test(email)) {
// //       $('#CustomOrderFormStatus').html(
// //         '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">✗ Please enter a valid email address.</div>'
// //       );
// //       return false;
// //     }
    
// //     // Store data for after submission
// //     var formData = {
// //       name: name,
// //       email: email,
// //       phone: phone,
// //       address: address,
// //       specs: specs,
// //       productName: form.find('input[name="contact[Product Name]"]').val() || 'Custom Product',
// //       productUrl: form.find('input[name="contact[Product URL]"]').val() || window.location.href,
// //       productVariant: form.find('input[name="contact[Product Variant]"]').val() || 'Standard'
// //     };
    
// //     try {
// //       sessionStorage.setItem('customOrderData', JSON.stringify(formData));
// //       console.log('✅ Form data saved to sessionStorage');
// //     } catch(e) {
// //       console.warn('Could not save to sessionStorage', e);
// //     }
    
// //     // Show loading state
// //     var submitBtn = form.find('.btn-submit-request');
// //     var originalText = submitBtn.html();
// //     submitBtn.html('⏳ SENDING...').prop('disabled', true);
// //     $('#CustomOrderFormStatus').html(
// //       '<div style="color: #856404; padding: 12px; background: #fff3cd; border-radius: 8px;">⏳ Sending your request...</div>'
// //     );
    
// //     // Submit the form natively (this will reload the page)
// //     form[0].submit();
    
// //     return true;
// //   }

// //   $(document).ready(function() {
// //     console.log('✅ Document ready');

// //     // ============================================================
// //     // CUSTOM ORDER BUTTON HANDLER
// //     // ============================================================
// //     $(document).on('click', '.btn-custom-order', function(e) {
// //       e.preventDefault();
// //       e.stopPropagation();
// //       e.stopImmediatePropagation();
      
// //       console.log('🔘 Custom Order button clicked');
      
// //       // Get product info
// //       var productName = $(this).data('product-name') || window.__productTitle || $('.product-title').text() || 'Custom Product';
// //       var productUrl = $(this).data('product-url') || window.location.href;
// //       var productVariant = $(this).data('product-variant') || $('.variant-selector option:selected').text() || '';

// //       $('#co-product-name').val(productName);
// //       $('#co-product-url').val(productUrl);
// //       $('#co-product-variant').val(productVariant);

// //       // Reset form
// //       $('#custom-order-form')[0].reset();
// //       $('#CustomOrderFormStatus').html('');

// //       // Show modal
// //       $('#CustomOrderModal').modal('show');
      
// //       return false;
// //     });

// //     // ============================================================
// //     // FORM SUBMIT HANDLER - Native submission
// //     // ============================================================
// //     var form = $('#custom-order-form');
// //     if (form.length > 0) {
// //       form.off('submit');
// //       form.on('submit', function(e) {
// //         e.preventDefault();
// //         return submitCustomOrder($(this));
// //       });
// //     }

// //     // ============================================================
// //     // CHECK FOR FORM SUBMISSION (after page reload)
// //     // ============================================================
// //     var urlParams = new URLSearchParams(window.location.search);
// //     if (urlParams.get('contact_posted') === 'true') {
// //       console.log('📋 Form was submitted successfully');
      
// //       setTimeout(function() {
// //         var storedData = sessionStorage.getItem('customOrderData');
// //         if (storedData) {
// //           try {
// //             var data = JSON.parse(storedData);
// //             console.log('📤 Found stored data, sending email...');
            
// //             // Send thank you email
// //             sendThankYouEmail(data);
            
// //             // Show popup
// //             showThankYouPopup();
            
// //             // Clear stored data
// //             setTimeout(function() {
// //               sessionStorage.removeItem('customOrderData');
// //             }, 3000);
// //           } catch(e) {
// //             console.warn('Could not parse stored data', e);
// //           }
// //         } else {
// //           console.log('⚠️ No stored data found, but form was submitted');
// //           showThankYouPopup();
// //         }
// //       }, 1000);
      
// //       // Clean URL
// //       if (window.history && window.history.replaceState) {
// //         var cleanUrl = window.location.pathname;
// //         window.history.replaceState({}, document.title, cleanUrl);
// //       }
// //     }

// //     // ============================================================
// //     // VARIANT CHANGE HANDLING
// //     // ============================================================
// //     var productTags = window.__productTags || [];
// //     if (productTags.indexOf('customize') !== -1) {
// //       console.log('✅ Customize product detected');
      
// //       function updateCustomButtons(available) {
// //         var customBtn = document.querySelector('.btn-custom-order');
// //         var addToCartBtn = document.querySelector('.btnAddToCart');
// //         var notifyBtn = document.querySelector('.btnsold_out.sold_out');
        
// //         if (!customBtn) return;

// //         if (available) {
// //           customBtn.style.display = 'block';
// //           if (addToCartBtn) addToCartBtn.style.display = 'none';
// //           if (notifyBtn) notifyBtn.style.display = 'none';
// //         } else {
// //           customBtn.style.display = 'none';
// //           if (addToCartBtn) addToCartBtn.style.display = 'none';
// //           if (notifyBtn) notifyBtn.style.display = 'flex';
// //         }
// //       }

// //       var variantInput = document.getElementById('variant_id');
// //       if (variantInput) {
// //         var observer = new MutationObserver(function() {
// //           var variants = window.__productVariants || [];
// //           var variant = variants.find(function(v) { return v.id == parseInt(variantInput.value); });
// //           if (variant) updateCustomButtons(variant.available);
// //         });
// //         observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        
// //         var initialVariant = window.__productVariants ? 
// //           window.__productVariants.find(function(v) { return v.id == parseInt(variantInput.value); }) : null;
// //         if (initialVariant) updateCustomButtons(initialVariant.available);
// //       }
// //     }

// //     console.log('✅ Custom Order ready');
// //   });

// // })();


// // ============================================================
// // CUSTOM ORDER - EmailJS (Both Store & Customer Emails)
// // ============================================================

// (function() {
  
//   console.log('🚀 Custom Order JS loaded');
  
//   // Initialize EmailJS
//   if (typeof emailjs !== 'undefined') {
//     emailjs.init("XZsjOIpLyMDQNMrIE");
//     console.log('✅ EmailJS initialized');
//   }

//   // Function to show Thank You popup
//   function showThankYouPopup() {
//     console.log('🎉 Showing Thank You popup');
//     if ($('#ThankYouModal').length > 0) {
//       $('#ThankYouModal').modal('show');
//       setTimeout(function() {
//         $('#ThankYouModal').modal('hide');
//       }, 5000);
//     } else {
//       console.log('❌ ThankYouModal not found');
//       alert('Thank you! Your custom order request has been sent. Our team will contact you within 24 hours.');
//     }
//   }

//   $(document).ready(function() {
//     console.log('✅ Document ready - setting up custom order');

//     // ✅ CUSTOM ORDER BUTTON CLICK HANDLER
//     $(document).on('click', '.btn-custom-order, .btn-custom-order-collection, .btn-made-to-order-quickview', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
//       e.stopImmediatePropagation();

//       console.log('🔘 Custom Order button clicked');

//       var productName = $(this).data('product-name') || $(this).data('product-title') || window.__productTitle || 'Custom Product';
//       var productUrl = $(this).data('product-url') || window.location.href;
//       var productVariant = $(this).data('product-variant') || '';

//       $('#co-product-name').val(productName);
//       $('#co-product-url').val(productUrl);
//       $('#co-product-variant').val(productVariant);

//       // Reset form
//       $('#custom-order-form')[0].reset();
//       $('#CustomOrderFormStatus').html('');

//       // Ensure modal is attached to body
//       if ($('#CustomOrderModal').parent()[0] !== document.body) {
//         $('#CustomOrderModal').appendTo('body');
//       }
      
//       // Close any other open modals
//       $('.modal.show').modal('hide');

//       // Show custom order modal
//       setTimeout(function() {
//         $('#CustomOrderModal').modal('show');
//       }, 300);
      
//       return false;
//     });

//     var form = $('#custom-order-form');
    
//     if (form.length === 0) {
//       console.log('⚠️ custom-order-form not found');
//       return;
//     }

//     // ✅ EMAILJS FORM SUBMISSION
//     form.on('submit', function(e) {
//       e.preventDefault();
      
//       var submitBtn = form.find('.btn-submit-request');
//       var originalText = submitBtn.html();
      
//       // Get form data
//       var fullName = form.find('input[name="full_name"]').val().trim();
//       var customerEmail = form.find('input[name="customer_email"]').val().trim();
//       var phone = form.find('input[name="phone"]').val().trim();
//       var address = form.find('textarea[name="address"]').val().trim();
//       var specifications = form.find('textarea[name="specifications"]').val().trim();
//       var productName = form.find('input[name="product_name"]').val() || 'Custom Product';
//       var productUrl = form.find('input[name="product_url"]').val() || window.location.href;
//       var productVariant = form.find('input[name="product_variant"]').val() || 'Standard';
      
//       // Validate
//       if (!fullName || !customerEmail || !phone || !specifications) {
//         $('#CustomOrderFormStatus').html(
//           '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">✗ Please fill in all required fields.</div>'
//         );
//         return false;
//       }
      
//       var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//       if (!emailRegex.test(customerEmail)) {
//         $('#CustomOrderFormStatus').html(
//           '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">✗ Please enter a valid email address.</div>'
//         );
//         return false;
//       }
      
//       // Show loading state
//       submitBtn.html('SENDING...').prop('disabled', true);
//       $('#CustomOrderFormStatus').html(
//         '<div style="color: #856404; padding: 12px; background: #fff3cd; border-radius: 8px;">⏳ Sending your request...</div>'
//       );
      
//       // Prepare data for both templates
//       var emailData = {
//         full_name: fullName,
//         customer_email: customerEmail,
//         phone: phone,
//         address: address || 'Not provided',
//         specifications: specifications,
//         product_name: productName,
//         product_variant: productVariant,
//         product_url: productUrl
//       };
      
//       console.log('📤 Sending emails with data:', emailData);
      
//       // ✅ STEP 1: Send Email to STORE TEAM (template_yac01n8)
//       emailjs.send(
//         "service_9t2yids",      // Your Service ID
//         "template_yac01n8",     // Store Team Template ID
//         emailData
//       ).then(function(storeResponse) {
//         console.log('✅ Store team email sent successfully');
        
//         // ✅ STEP 2: Send Thank You Email to CUSTOMER (template_3xv47ep)
//         emailjs.send(
//           "service_9t2yids",      // Your Service ID
//           "template_3xv47ep",     // Customer Auto-Reply Template ID
//           emailData
//         ).then(function(customerResponse) {
//           console.log('✅ Customer thank you email sent successfully');
          
//           // Show success
//           $('#CustomOrderFormStatus').html(
//             '<div style="color: #155724; padding: 12px; background: #d4edda; border-radius: 8px;">✅ Request sent successfully! Check your email for confirmation.</div>'
//           );
          
//           // Close modal and show thank you
//           setTimeout(function() {
//             $('#CustomOrderModal').modal('hide');
//             setTimeout(function() {
//               showThankYouPopup();
//               form[0].reset();
//               submitBtn.html(originalText).prop('disabled', false);
//             }, 300);
//           }, 500);
          
//         }).catch(function(customerError) {
//           console.error('❌ Customer email error:', customerError);
//           // Still show success since store got the email
//           $('#CustomOrderFormStatus').html(
//             '<div style="color: #155724; padding: 12px; background: #d4edda; border-radius: 8px;">✅ Request sent! (Confirmation email pending)</div>'
//           );
//           setTimeout(function() {
//             $('#CustomOrderModal').modal('hide');
//             setTimeout(function() {
//               showThankYouPopup();
//               form[0].reset();
//               submitBtn.html(originalText).prop('disabled', false);
//             }, 300);
//           }, 500);
//         });
        
//       }).catch(function(storeError) {
//         console.error('❌ Store team email error:', storeError);
        
//         // Retry: Try sending just the store email again
//         emailjs.send(
//           "service_9t2yids",
//           "template_yac01n8",
//           emailData
//         ).then(function(retryResponse) {
//           console.log('✅ Store email sent on retry');
//           $('#CustomOrderFormStatus').html(
//             '<div style="color: #155724; padding: 12px; background: #d4edda; border-radius: 8px;">✅ Request sent successfully!</div>'
//           );
//           setTimeout(function() {
//             $('#CustomOrderModal').modal('hide');
//             setTimeout(function() {
//               showThankYouPopup();
//               form[0].reset();
//               submitBtn.html(originalText).prop('disabled', false);
//             }, 300);
//           }, 500);
//         }).catch(function(retryError) {
//           console.error('❌ Both attempts failed:', retryError);
//           $('#CustomOrderFormStatus').html(
//             '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">❌ Error sending request. Please email us directly at demotn26@gmail.com</div>'
//           );
//           submitBtn.html(originalText).prop('disabled', false);
//         });
//       });
      
//       return false;
//     });

//     // ============================================================
//     // VARIANT CHANGE HANDLING - ONLY FOR CUSTOMIZE PRODUCTS
//     // ============================================================
//     var productTags = window.__productTags || [];
//     var isCustomize = productTags.indexOf('customize') !== -1;

//     if (isCustomize) {
//       console.log('✅ Customize product detected on product page');
//       var variants = window.__productVariants || [];

//       function getVariantById(id) {
//         return variants.find(function(v) { return v.id == id; });
//       }

//       function updateCustomButtons(available) {
//         var customBtn = document.querySelector('.btn-custom-order');
//         var addToCartBtn = document.querySelector('.btnAddToCart');
//         var notifyBtn = document.querySelector('.btnsold_out.sold_out');
        
//         if (!customBtn) {
//           console.log('⚠️ .btn-custom-order not found');
//           return;
//         }
        
//         console.log('🔄 Updating buttons - available:', available);

//         if (available) {
//           customBtn.style.setProperty('display', 'block', 'important');
//           if (addToCartBtn) addToCartBtn.style.setProperty('display', 'none', 'important');
//           if (notifyBtn) notifyBtn.style.setProperty('display', 'none', 'important');
//         } else {
//           customBtn.style.setProperty('display', 'none', 'important');
//           if (addToCartBtn) addToCartBtn.style.setProperty('display', 'none', 'important');
//           if (notifyBtn) notifyBtn.style.setProperty('display', 'flex', 'important');
//         }
//       }

//       var variantInput = document.getElementById('variant_id');
//       if (variantInput) {
//         var observer = new MutationObserver(function() {
//           var variant = getVariantById(parseInt(variantInput.value));
//           if (variant) updateCustomButtons(variant.available);
//         });
//         observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        
//         var initialVariant = getVariantById(parseInt(variantInput.value));
//         if (initialVariant) updateCustomButtons(initialVariant.available);
//       }

//       document.addEventListener('change', function(e) {
//         if (e.target.classList.contains('jash-click')) {
//           setTimeout(function() {
//             var input = document.getElementById('variant_id');
//             if (!input) return;
//             var variant = getVariantById(parseInt(input.value));
//             if (variant) updateCustomButtons(variant.available);
//           }, 150);
//         }
//       });
//     } else {
//       console.log('ℹ️ Regular product - no customize tag, skipping button logic');
//     }

//   });

// })();

// ============================================================
// CUSTOM ORDER - EmailJS (Both Store & Customer Emails)
// ============================================================

(function() {
  
  console.log('🚀 Custom Order JS loaded');
  
  // Initialize EmailJS
  if (typeof emailjs !== 'undefined') {
    emailjs.init("XZsjOIpLyMDQNMrIE");
    console.log('✅ EmailJS initialized');
  }

  // Function to show Thank You popup
  function showThankYouPopup() {
    console.log('🎉 Showing Thank You popup');
    if ($('#ThankYouModal').length > 0) {
      $('#ThankYouModal').modal('show');
      setTimeout(function() {
        $('#ThankYouModal').modal('hide');
      }, 5000);
    } else {
      console.log('❌ ThankYouModal not found');
      alert('Thank you! Your custom order request has been sent. Our team will contact you within 24 hours.');
    }
  }

  $(document).ready(function() {
    console.log('✅ Document ready - setting up custom order');

    // ✅ CUSTOM ORDER BUTTON CLICK HANDLER
    $(document).on('click', '.btn-custom-order, .btn-custom-order-collection, .btn-made-to-order-quickview', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      console.log('🔘 Custom Order button clicked');

      var productName = $(this).data('product-name') || $(this).data('product-title') || window.__productTitle || 'Custom Product';
      var productUrl = $(this).data('product-url') || window.location.href;
      var productVariant = $(this).data('product-variant') || '';

      $('#co-product-name').val(productName);
      $('#co-product-url').val(productUrl);
      $('#co-product-variant').val(productVariant);

      // Reset form
      $('#custom-order-form')[0].reset();
      $('#CustomOrderFormStatus').html('');

      // Ensure modal is attached to body
      if ($('#CustomOrderModal').parent()[0] !== document.body) {
        $('#CustomOrderModal').appendTo('body');
      }
      
      // Close any other open modals
      $('.modal.show').modal('hide');

      // Show custom order modal
      setTimeout(function() {
        $('#CustomOrderModal').modal('show');
      }, 300);
      
      return false;
    });

    var form = $('#custom-order-form');
    
    if (form.length === 0) {
      console.log('⚠️ custom-order-form not found');
      return;
    }

    // ✅ EMAILJS FORM SUBMISSION
    form.on('submit', function(e) {
      e.preventDefault();
      
      var submitBtn = form.find('.btn-submit-request');
      var originalText = submitBtn.html();
      
      // Get form data
      var fullName = form.find('input[name="full_name"]').val().trim();
      var customerEmail = form.find('input[name="customer_email"]').val().trim();
      var phone = form.find('input[name="phone"]').val().trim();
      var address = form.find('textarea[name="address"]').val().trim();
      var specifications = form.find('textarea[name="specifications"]').val().trim();
      var productName = form.find('input[name="product_name"]').val() || 'Custom Product';
      var productUrl = form.find('input[name="product_url"]').val() || window.location.href;
      var productVariant = form.find('input[name="product_variant"]').val() || 'Standard';
      
      // Validate
      if (!fullName || !customerEmail || !phone || !specifications) {
        $('#CustomOrderFormStatus').html(
          '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">✗ Please fill in all required fields.</div>'
        );
        return false;
      }
      
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(customerEmail)) {
        $('#CustomOrderFormStatus').html(
          '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">✗ Please enter a valid email address.</div>'
        );
        return false;
      }
      
      // Show loading state
      submitBtn.html('SENDING...').prop('disabled', true);
      $('#CustomOrderFormStatus').html(
        '<div style="color: #856404; padding: 12px; background: #fff3cd; border-radius: 8px;">⏳ Sending your request...</div>'
      );
      
      // Prepare data for both templates
      var emailData = {
        full_name: fullName,
        customer_email: customerEmail,
        phone: phone,
        address: address || 'Not provided',
        specifications: specifications,
        product_name: productName,
        product_variant: productVariant,
        product_url: productUrl
      };
      
      console.log('📤 Sending emails with data:', emailData);
      
      // ✅ STEP 1: Send Email to STORE TEAM (template_yac01n8)
      emailjs.send(
        "service_9t2yids",      // Your Service ID
        "template_yac01n8",     // Store Team Template ID
        emailData
      ).then(function(storeResponse) {
        console.log('✅ Store team email sent successfully');
        
        // ✅ STEP 2: Send Thank You Email to CUSTOMER (template_3xv47ep)
        emailjs.send(
          "service_9t2yids",      // Your Service ID
          "template_3xv47ep",     // Customer Auto-Reply Template ID
          emailData
        ).then(function(customerResponse) {
          console.log('✅ Customer thank you email sent successfully');
          
          // Show success
          $('#CustomOrderFormStatus').html(
            '<div style="color: #155724; padding: 12px; background: #d4edda; border-radius: 8px;">✅ Request sent successfully! Check your email for confirmation.</div>'
          );
          
          // Close modal and show thank you
          setTimeout(function() {
            $('#CustomOrderModal').modal('hide');
            setTimeout(function() {
              showThankYouPopup();
              form[0].reset();
              submitBtn.html(originalText).prop('disabled', false);
            }, 300);
          }, 500);
          
        }).catch(function(customerError) {
          console.error('❌ Customer email error:', customerError);
          // Still show success since store got the email
          $('#CustomOrderFormStatus').html(
            '<div style="color: #155724; padding: 12px; background: #d4edda; border-radius: 8px;">✅ Request sent! (Confirmation email pending)</div>'
          );
          setTimeout(function() {
            $('#CustomOrderModal').modal('hide');
            setTimeout(function() {
              showThankYouPopup();
              form[0].reset();
              submitBtn.html(originalText).prop('disabled', false);
            }, 300);
          }, 500);
        });
        
      }).catch(function(storeError) {
        console.error('❌ Store team email error:', storeError);
        
        // Retry: Try sending just the store email again
        emailjs.send(
          "service_9t2yids",
          "template_yac01n8",
          emailData
        ).then(function(retryResponse) {
          console.log('✅ Store email sent on retry');
          $('#CustomOrderFormStatus').html(
            '<div style="color: #155724; padding: 12px; background: #d4edda; border-radius: 8px;">✅ Request sent successfully!</div>'
          );
          setTimeout(function() {
            $('#CustomOrderModal').modal('hide');
            setTimeout(function() {
              showThankYouPopup();
              form[0].reset();
              submitBtn.html(originalText).prop('disabled', false);
            }, 300);
          }, 500);
        }).catch(function(retryError) {
          console.error('❌ Both attempts failed:', retryError);
          $('#CustomOrderFormStatus').html(
            '<div style="color: #721c24; padding: 12px; background: #f8d7da; border-radius: 8px;">❌ Error sending request. Please email us directly at demotn26@gmail.com</div>'
          );
          submitBtn.html(originalText).prop('disabled', false);
        });
      });
      
      return false;
    });

    // ============================================================
    // VARIANT CHANGE HANDLING - ONLY FOR CUSTOMIZE PRODUCTS
    // ============================================================
    var productTags = window.__productTags || [];
    var isCustomize = productTags.indexOf('customize') !== -1;

    if (isCustomize) {
      console.log('✅ Customize product detected on product page');
      var variants = window.__productVariants || [];

      function getVariantById(id) {
        return variants.find(function(v) { return v.id == id; });
      }

      function updateCustomButtons(available) {
        var customBtn = document.querySelector('.btn-custom-order');
        var addToCartBtn = document.querySelector('.btnAddToCart');
        var notifyBtn = document.querySelector('.btnsold_out.sold_out');
        
        if (!customBtn) {
          console.log('⚠️ .btn-custom-order not found');
          return;
        }
        
        console.log('🔄 Updating buttons - available:', available);

        if (available) {
          customBtn.style.setProperty('display', 'block', 'important');
          if (addToCartBtn) addToCartBtn.style.setProperty('display', 'none', 'important');
          if (notifyBtn) notifyBtn.style.setProperty('display', 'none', 'important');
        } else {
          customBtn.style.setProperty('display', 'none', 'important');
          if (addToCartBtn) addToCartBtn.style.setProperty('display', 'none', 'important');
          if (notifyBtn) notifyBtn.style.setProperty('display', 'flex', 'important');
        }
      }

      var variantInput = document.getElementById('variant_id');
      if (variantInput) {
        var observer = new MutationObserver(function() {
          var variant = getVariantById(parseInt(variantInput.value));
          if (variant) updateCustomButtons(variant.available);
        });
        observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        
        var initialVariant = getVariantById(parseInt(variantInput.value));
        if (initialVariant) updateCustomButtons(initialVariant.available);
      }

      document.addEventListener('change', function(e) {
        if (e.target.classList.contains('jash-click')) {
          setTimeout(function() {
            var input = document.getElementById('variant_id');
            if (!input) return;
            var variant = getVariantById(parseInt(input.value));
            if (variant) updateCustomButtons(variant.available);
          }, 150);
        }
      });
    } else {
      console.log('ℹ️ Regular product - no customize tag, skipping button logic');
    }

    // ============================================================
    // ✅ QUICKVIEW HANDLING - Show/Hide CUSTOM ORDER button
    // ============================================================
    
    // Listen for quickview modal opening
    $(document).on('show.bs.modal', '#quickviewModal', function() {
      console.log('🔍 Quickview modal opening - checking for customize product');
      
      // Wait for product data to load in quickview
      setTimeout(function() {
        var customBtn = document.getElementById('qv-btnCustomOrder');
        var addToCartBtn = document.getElementById('qv-btnAddToCart');
        
        if (!customBtn || !addToCartBtn) {
          console.log('⚠️ Quickview buttons not found');
          return;
        }
        
        // Check if product has customize tag from the quickview data
        // Get product tags from the quickview container
        var productTags = [];
        var productHandle = $('.quickviewName a').attr('href');
        if (productHandle) {
          // Try to get tags from data attribute
          var tagsAttr = $('.productQuickView a[data-handle]').data('tags');
          if (tagsAttr) {
            productTags = tagsAttr.split(',');
          }
        }
        
        // Also check window.__quickviewProductTags if available
        if (window.__quickviewProductTags) {
          productTags = window.__quickviewProductTags;
        }
        
        var isCustomize = productTags.indexOf('customize') !== -1;
        
        console.log('🔄 Quickview - isCustomize:', isCustomize);
        
        if (isCustomize) {
          // Show CUSTOM ORDER, hide ADD TO CART
          customBtn.style.display = 'block';
          addToCartBtn.style.display = 'none';
          console.log('✅ Quickview: Showing CUSTOM ORDER button');
        } else {
          // Show ADD TO CART, hide CUSTOM ORDER
          customBtn.style.display = 'none';
          addToCartBtn.style.display = 'block';
          console.log('✅ Quickview: Showing ADD TO CART button');
        }
      }, 500);
    });

    // Also handle when quickview is loaded via AJAX
    $(document).ajaxComplete(function(event, xhr, settings) {
      // Check if this is the quickview request
      if (settings.url && settings.url.indexOf('view=quick_view') !== -1) {
        console.log('🔄 Quickview AJAX loaded - checking buttons');
        
        setTimeout(function() {
          var customBtn = document.getElementById('qv-btnCustomOrder');
          var addToCartBtn = document.getElementById('qv-btnAddToCart');
          
          if (!customBtn || !addToCartBtn) return;
          
          // Check if the product in quickview has customize tag
          // Look for the product tags in the quickview data
          var isCustomize = false;
          
          // Check if any element in quickview has the customize tag
          $('.proBoxInfo').find('[data-tags]').each(function() {
            var tags = $(this).data('tags');
            if (tags && tags.indexOf('customize') !== -1) {
              isCustomize = true;
            }
          });
          
          // Also check if the quickview URL contains product handle that has customize tag
          var productHandle = $('.quickviewName a').attr('href');
          if (productHandle) {
            // Check if we have stored tags for this product
            var storedTags = sessionStorage.getItem('qv_tags_' + productHandle);
            if (storedTags && storedTags.indexOf('customize') !== -1) {
              isCustomize = true;
            }
          }
          
          if (isCustomize) {
            customBtn.style.display = 'block';
            addToCartBtn.style.display = 'none';
            console.log('✅ Quickview AJAX: Showing CUSTOM ORDER button');
          } else {
            customBtn.style.display = 'none';
            addToCartBtn.style.display = 'block';
            console.log('✅ Quickview AJAX: Showing ADD TO CART button');
          }
        }, 300);
      }
    });

  });

})();